// ⚠️ ONE place for Mithralaya's contact details — used by the footer and
// the Contact page so they can never disagree again. Please confirm the
// email, phone and pincode (Madambakkam is 600126; the old footer said 600119).
// Social links: fill in the real Mithralaya pages; empty ones are hidden.
const CONTACT = {
  email: process.env.REACT_APP_CONTACT_EMAIL || 'hello@mithralaya.in',
  phone: '+91 90439 02239',
  phoneHref: 'tel:+919043902239',
  whatsapp: 'https://wa.me/919043902239',
  addressLines: [
    'No. 72, Ground Floor, Varadharaj Flats',
    'Thenuganapathy Nagar, 3rd Cross Street',
    'Madambakkam, Chennai, Tamil Nadu 600126'
  ],
  hours: 'Monday to Saturday, 10 am – 7 pm',
  social: {
    instagram: process.env.REACT_APP_INSTAGRAM_URL || '',
    facebook: process.env.REACT_APP_FACEBOOK_URL || '',
    youtube: process.env.REACT_APP_YOUTUBE_URL || ''
  }
};

export default CONTACT;
